var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2056_46586",
    transform: "translate(-0.0869565 -0.0869565) scale(0.0121739)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2056_46586",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4klEQVR4nO3cu0ocURyA8dEqGLARUifxbkpJShvBeOlMXsTOXhvfRPARQiCSQgJpLVII60qiDxCIJsUXBFNpdA/snPP3zPd7gJ0/8+1ldi6naSRJkiRJkiRJkiRJkiRJkjREwBiwDXwCjoA94Nkwt6EBAePAV247A+YGfR0NCbDL//0wSmbAMfe7ABZyz9VZQO+BIEbJHGSfwXwHZrMO10XAK+BnQpSZ0jNXD1gFfiVEmS49c/WAlYQo1z/086Vnrh5pUc6NkoFRHn+UM2Cq9MzVwyjxYJQqokyWnrl6pEXpGyUDowSEn5R4MEoVUV42kQCvgc/AJd3UA543EQDLwFXpPRIkyovSMUaAb6X3RCD9oqdZrjdeeg8EVO7Ko0HiBRkFTu6eq5P6xc8MA0vAn9J7IoDyP+r/AIvAx4Rj99r0whz21gh4m/DmOg33x7DDMfrGiHO7kKfh22SMQIA1PxlBYIw4gPWEM9ReTw8Ww3uz2gJsGCMIjBEHsAn8HvBryput2wS8M0YQwPuEGD6w03KMNwnX/H2krW3AQUIMH/rMEOTEGIEAXx4I4sIBmYPs3BPDpTVyA57erAB01/UMF58pAXgCbAEfgMObBWkmigwjSZIkSZIkSZIkSZIkSZLURPEXqmOk4fWrSIkAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.8a2d8b9a12e9d692278ede7651eaddea.svg";
export { ForwardRef as ReactComponent };